import React from 'react';

const RouteNotFound = () => {
    return (
        <div style={{ textAlign: 'center', color: 'tomato', marginTop: '3rem'}}>
            <h1>404</h1>
            <h3>Page Not Found</h3>
        </div>
    );
};

export default RouteNotFound;